<template>
  <BaseNotificationDialog :is-open="isOpen">
    <div class="mb-4 flex items-center justify-between">
      <div class="flex-1" />
      <h2
        class="flex items-center text-xl font-medium text-positive"
      >
        Update Successful
        <IconCheckCircle class="ml-1" />
      </h2>
      <div class="flex flex-1 items-center justify-end">
        <button
          class="flex items-center"
          type="button"
          @click="acknowledgeUpdate"
        >
          <IconX />
        </button>
      </div>
    </div>

    <div class="text-center">
      <p>
        {{ organizationConfig?.appName }}
        updated to
      </p>
      <p class="mt-2 text-xl font-semibold">
        {{ appVersion }}
      </p>
      <p
        v-if="previousVersion"
        class="mt-2 text-sm text-background-fg/80"
      >
        (previously
        <span class="font-semibold">{{
          previousVersion
        }}</span
        >)
      </p>

      <ActionButtonSecondary
        class="mt-4 w-full"
        @click="acknowledgeUpdate"
      >
        Got it
      </ActionButtonSecondary>
    </div>
  </BaseNotificationDialog>
</template>

<script setup lang="ts">
import { useOrganizationConfig } from "@/services/organizations/retrieveOrganizationConfig"

defineProps<{
  isOpen: boolean
  previousVersion?: string | null
}>()

const emit = defineEmits<{
  (
    eventName: "acknowledge",
    version: string | undefined
  ): void
}>()

const { organizationConfig } = useOrganizationConfig()
const { appVersion } = useDevice()

const acknowledgeUpdate = () =>
  emit("acknowledge", appVersion.value)
</script>
